// Routes.tsx
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import routes, { RouteItem } from '../configs/routeConfig';
import { CircularProgress } from '@mui/material';
import { Grid } from '@mui/material';

import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const renderRoutes = (routeItems: RouteItem[]): React.ReactNode => {
  return routeItems.map((route, idx) => {
    const Layout = route.layout || React.Fragment;
    const RouteWrapper = route.isPrivate ? PrivateRoute : route.isPublic ? PublicRoute : React.Fragment;

    return (
      <Route
        key={idx}
        path={route.path}
        element={
          <RouteWrapper>
            <Suspense
              fallback={
                <Grid
                  sx={{
                    display: 'flex',
                    justifyContent: 'center', // center horizontally
                    alignItems: 'center', // center vertically
                    height: '100vh', // full viewport height
                    width: '100vw',
                  }}
                >
                  <CircularProgress />
                </Grid>
              }
            >
              <Layout>{route.component ? <route.component /> : <></>}</Layout>
            </Suspense>
          </RouteWrapper>
        }
      >
        {route.children && renderRoutes(route.children)}
      </Route>
    );
  });
};

const RouteMapper: React.FC = () => {
  console.log(routes);
  return (
    <Router>
      <Routes>{renderRoutes(routes)}</Routes>
    </Router>
  );
};

export default RouteMapper;
